function clampLevel(
  value,
  levelCount
) {
  const safeCount =
    Math.max(
      1,
      Math.floor(
        Number(levelCount) || 1
      )
    );

  return Math.max(
    1,
    Math.min(
      safeCount,
      Math.floor(
        Number(value) || 1
      )
    )
  );
}


export function createDefaultProgress(
  levelCount
) {
  return {
    version: 4,
    highestUnlocked:
      clampLevel(
        1,
        levelCount
      ),
    completed: {}
  };
}


export function projectHomeProgress(
  home,
  levelCount
) {
  const safeCount =
    Math.max(
      1,
      Math.floor(
        Number(levelCount) || 1
      )
    );

  if (
    !home
    || typeof home !== "object"
  ) {
    return createDefaultProgress(
      safeCount
    );
  }

  const campaignCompleted =
    home.campaign_completed
    === true;

  const currentLevel =
    campaignCompleted
      ? safeCount
      : clampLevel(
          home.current_level_no,
          safeCount
        );

  const completed = {};

  if (campaignCompleted) {
    for (
      let level = 1;
      level <= safeCount;
      level += 1
    ) {
      completed[String(level)] =
        true;
    }
  } else {
    for (
      let level = 1;
      level < currentLevel;
      level += 1
    ) {
      completed[String(level)] =
        true;
    }
  }

  return {
    version: 4,
    highestUnlocked:
      currentLevel,
    completed
  };
}


/*
 * Runtime fallback only.
 *
 * Official account progress is never loaded
 * from browser persistence.
 */
export function loadProgress(
  levelCount
) {
  return createDefaultProgress(
    levelCount
  );
}


export function isLevelCompleted(
  progress,
  level
) {
  return Boolean(
    progress
      ?.completed
      ?.[String(level)]
  );
}


export function isLevelUnlocked(
  progress,
  level
) {
  const target =
    Math.floor(
      Number(level) || 0
    );

  return (
    target >= 1
    && target <= Number(
      progress?.highestUnlocked
      || 1
    )
  );
}
